import { render, staticRenderFns } from "./contractorsAdd.vue?vue&type=template&id=48a4b6cc&scoped=true&"
import script from "./contractorsAdd.vue?vue&type=script&lang=js&"
export * from "./contractorsAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a4b6cc",
  null
  
)

export default component.exports